import { FormSection } from "components/MainSectionTemplate/types";
import React from "react";
import BirthdateRow from "../detail/components/BirthdateRow";
import { getMaritalStatus } from "../detail/components/MaritalStatusRow";
import { getInstruction, ContactFormState } from "shared/utils/fieldsHelper/contactFields";
import { isNullOrEmptyString } from "shared/utils";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import OptionalTextAreaInput from "components/ValidatedFields/OptionalTextAreaInput";
import { MaritalStatusRadio } from "contact/detail/components/MaritalStatusRadio";
import { OptionalDatePicker } from "components/DatePicker/OptionalDatePicker";
import moment from "moment";
import { newLineToBr } from "utilities/newlinetobr";

export const otherDetailSection = (contact: server.dto.Contact, formState: ContactFormState): FormSection => {
  return {
    type: "collapsable",
    key: "contactOtherDetails",
    title: RESX.Company.OtherDetails,
    fields: [{
      key: "socialSecurity",
      label: RESX.Contact.SocialSecurity,
      render: () => <div>{formState.socialSecurity}</div>,
      isEmpty: isNullOrEmptyString(formState.socialSecurity),
      inPageEdit: {
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.contact.maxSocialSecurityLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.socialSecurity,
        submitChange: (value: string) => {
          const instruction = getInstruction(contact, formState, {
            socialSecurity: value,
          });
          return window.CoreApi.Contact.UpdateDetails(instruction);
        }
      }
    }, {
      key: "birthdate",
      label: RESX.Contact.DateOfBirth,
      render: () => <BirthdateRow birthdate={formState.birthdate} />,
      isEmpty: !formState.birthdate,
      inPageEdit: {
        initialValue: formState.birthdate,
        render: ({ value, onChange }) => (
          <div className="main-section-template-fields-padding">
            <OptionalDatePicker
              focusOnMount
              value={value}
              onChange={v => onChange(v)}
              minDate={moment.utc("1900-01-01")}
              maxDate={moment.utc()}
              validatorKey="contactBirthdate"
            />
          </div>
        ),
        type: "confirmOrCancelButton",
        submitChange: (value: moment.Moment | null) => {
          const instruction = getInstruction(contact, formState, {
            birthdate: value?.toDate(),
          });
          return window.CoreApi.Contact.UpdateDetails(instruction);
        }
      }

    }, {
      key: "birthplace",
      label: RESX.Contact.PlaceOfBirth,
      render: () => <div>{formState.birthplace}</div>,
      isEmpty: isNullOrEmptyString(formState.birthplace),
      inPageEdit: {
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.contact.maxBirthPlaceLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.birthplace,
        submitChange: (value: string) => {
          const instruction = getInstruction(contact, formState, {
            birthplace: value,
          });
          return window.CoreApi.Contact.UpdateDetails(instruction);
        }
      }
    }, {
      key: "maritalStatus",
      label: RESX.Contact.MaritalStatus,
      render: () => getMaritalStatus(formState.maritalStatus),
      isEmpty: !formState.maritalStatus || formState.maritalStatus === "unknown",
      inPageEdit: {
        render: ({ value, onChange }) => (
          <div className="main-section-template-fields-padding">
            <MaritalStatusRadio
              value={value || "unknown"}
              onChange={v => onChange(v, true)}
            />
          </div>
        ),
        type: "custom",
        initialValue: formState.maritalStatus,
        submitChange: (value) => {
          const instruction = getInstruction(contact, formState, {
            maritalStatus: value,
          });
          return window.CoreApi.Contact.UpdateDetails(instruction);
        }
      }
    }, {
      key: "additionalInformation",
      label: RESX.Company.AdditionalInformation,
      render: () => newLineToBr(formState.additionalInformation),
      isEmpty: isNullOrEmptyString(formState.additionalInformation),
      inPageEdit: {
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextAreaInput
            focusOnMount
            rows={3}
            value={value}
            onChange={onChange}
            onCtrlEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.contact.maxAdditionalLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.additionalInformation,
        submitChange: (value: string) => {
          const instruction = getInstruction(contact, formState, { additional: value });
          return window.CoreApi.Contact.UpdateDetails(instruction);
        }
      }
    }]
  }
}
